var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcWithdrawn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.5836 14.0911C17.2766 13.7841 16.7793 13.7841 16.4724 14.0911L15.3688 15.1946L14.2653 14.0911C13.9583 13.7841 13.461 13.7841 13.1541 14.0911C12.8471 14.398 12.8471 14.8953 13.1541 15.2023L14.2576 16.3058L13.1541 17.4094C12.8471 17.7164 12.8471 18.2136 13.1541 18.5206C13.3075 18.6741 13.5086 18.7508 13.7097 18.7508C13.9107 18.7508 14.1118 18.6741 14.2653 18.5206L15.3688 17.4171L16.4724 18.5206C16.6259 18.6741 16.8269 18.7508 17.028 18.7508C17.2291 18.7508 17.4301 18.6741 17.5836 18.5206C17.8906 18.2136 17.8906 17.7164 17.5836 17.4094L16.4801 16.3058L17.5836 15.2023C17.8906 14.8953 17.8906 14.398 17.5836 14.0911Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.4885 6.84418V11.9156C16.4885 12.2611 16.7684 12.5406 17.1135 12.5406C17.4587 12.5406 17.7385 12.2611 17.7385 11.9156V6.21643C17.7231 6.04446 17.658 5.88241 17.5347 5.75806L12.7874 1.41388C12.6716 1.30425 12.5168 1.26686 12.365 1.25H4.3349C3.1496 1.25 2.18555 2.21436 2.18555 3.39966V16.5271C2.18555 17.7118 3.1496 18.6761 4.3349 18.6761H10.9774C11.3226 18.6761 11.6024 18.3966 11.6024 18.0511C11.6024 17.7057 11.3226 17.4261 10.9774 17.4261H4.3349C3.83899 17.4261 3.43555 17.0227 3.43555 16.5271V3.39966C3.43555 2.90344 3.83899 2.5 4.3349 2.5H11.7403V4.69757C11.7403 5.88135 12.7031 6.84418 13.8869 6.84418H16.4885ZM12.9903 4.69757V3.29407L15.5037 5.59418H13.8869C13.3925 5.59418 12.9903 5.19196 12.9903 4.69757Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.00195 9.96216C6.00195 10.3073 6.2818 10.5872 6.62695 10.5872H11.2213C11.5664 10.5872 11.8463 10.3073 11.8463 9.96216C11.8463 9.617 11.5664 9.33716 11.2213 9.33716H6.62695C6.2818 9.33716 6.00195 9.617 6.00195 9.96216Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.70117 13.8489H11.224C11.5692 13.8489 11.849 13.5693 11.849 13.2239C11.849 12.8784 11.5692 12.5989 11.224 12.5989H6.70117C6.35602 12.5989 6.07617 12.8784 6.07617 13.2239C6.07617 13.5693 6.35602 13.8489 6.70117 13.8489Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.96259 6.07568H6.70117C6.35602 6.07568 6.07617 6.35553 6.07617 6.70068C6.07617 7.04584 6.35602 7.32568 6.70117 7.32568H9.96259C10.3077 7.32568 10.5876 7.04584 10.5876 6.70068C10.5876 6.35553 10.3077 6.07568 9.96259 6.07568Z",
    fill: "#757575"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWithdrawn);
export default __webpack_public_path__ + "static/media/ic-withdrawn.cc827579beee80cb4181672aea7d1c5c.svg";
export { ForwardRef as ReactComponent };